import React from "react";
import { Link } from "react-router-dom";
import { 
  FaFacebook, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedin, 
  FaYoutube 
} from 'react-icons/fa';


export default function Footer() {
  return (
    <div className="w-full bg-[#23262F] text-white ">
      <div className="mx-auto flex w-11/12 flex-wrap items-center justify-between md:w-10/12">
        {/* Left Section */}
        <div className="w-10/12 md:w-[30%]">
          <p className="text-[20px] font-[700] leading-8 md:text-[24px] md:leading-[32px] sm:mt-8">
            Let's make a great design together!
          </p>
          <img 
            src={"https://us.designelementary.com/footer/footerlogo.svg"}
            alt="Design Elementary" 
            className="my-4 w-auto h-auto max-w-[200px]"
          />
          
          {/* Certificates Section - Added this new section */}
          <div className="mb-6 ">
            <p className="text-[16px] font-[500] mb-2 ">Proudly Registered Under</p>
            <div className="flex items-center space-x-4">
              <div className="flex flex-col items-center">
                <img 
                  src={require("../assets/msme.png")}// Replace with your first certificate image
                  alt="Happy Users" 
                  className="w-[80px]"
                />
              </div>
              <div className="flex flex-col items-center">
                <img 
                  src={require("../assets/startup.png")} // Replace with your second certificate image
                  alt="GetApp" 
                  className="w-[80px]"
                />
              </div>
            </div>
          </div>
          
          <p className="hidden text-[12px] font-[400] leading-[20px] md:block">
            © {new Date().getFullYear()} Design Elementary. All rights reserved
          </p>
        </div>

        {/* Rest of your existing footer code remains the same */}
        {/* Right Sections */}
        <div className="my-0 flex w-full flex-wrap items-start justify-between md:justify-evenly md:my-4 md:w-[68%]">
          <div className="divider divider-horizontal opacity-[0.1] before:bg-[#E6E8EC!important] after:bg-[#E6E8EC!important] hidden md:flex"></div>
          
          {/* Company Links */}
          <div className="my-4 mx-2 w-fit md:w-auto">
            <p className="text-[16px] font-[500] leading-[24px]">Company</p>
            <div className="mt-2 md:mt-8">
              <p className="text-[14px] font-[700] leading-[24px]">
                <Link to="/career">Careers</Link>
              </p>
              <p className="text-[14px] font-[700] leading-[24px]">
                <Link to="/policies">Policies</Link>
              </p>
              <p className="text-[14px] font-[700] leading-[24px]">
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </p>
              <p className="text-[14px] font-[700] leading-[24px]">
                <Link to="/">FAQ's</Link>
              </p>
              <p className="text-[14px] font-[700] leading-[24px]">
                <Link to="/about">About Us</Link>
              </p>
              <p className="text-[14px] font-[700] leading-[24px]">
                <Link to="/contact">Contact Us</Link>
              </p>
              <p className="text-[14px] font-[700] leading-[24px]">
                <Link to="/cities">Cities</Link>
              </p>
            </div>
          </div>

          <div className="divider divider-horizontal opacity-[0.1] before:bg-[#E6E8EC!important] after:bg-[#E6E8EC!important] hidden md:flex"></div>

          {/* Services Links */}
          <div className="my-4 mx-2 w-fit md:w-auto">
            <p className="text-[16px] font-[500] leading-[24px]">Services</p>
            <div className="mt-2 md:mt-8">
              <p className="text-[14px] font-[700] leading-[24px]">
                <Link to="/architecture">Architecture</Link>
              </p>
              <p className="text-[14px] font-[700] leading-[24px]">
                <Link to="/interior">Interior Design</Link>
              </p>
              <p className="text-[14px] font-[700] leading-[24px]">
                <Link to="/site-supervision-and-quality-audit">PMC</Link>
              </p>
              <p className="text-[14px] font-[700] leading-[24px]">
                <Link to="/">Material procurement</Link>
              </p>
              <p className="text-[14px] font-[700] leading-[24px]">
                <Link to="/">Finance</Link>
              </p>
              <p className="text-[14px] font-[700] leading-[24px]">
                <Link to="/user/profile/design-ai">Design AI</Link>
              </p>
              <p className="text-[14px] font-[700] leading-[24px]">
                <Link to="/cost-calculator">Cost Calculator</Link>
              </p>
            </div>
          </div>

          <div className="divider divider-horizontal opacity-[0.1] before:bg-[#E6E8EC!important] after:bg-[#E6E8EC!important] hidden md:flex"></div>

          {/* Contact Section */}
          <div className="my-4 w-11/12 md:w-auto">
            <p className="text-[16px] font-[500] leading-[24px]">Contacts</p>
            <div className="mt-2 md:mt-8">
              <a href="tel:+917892516337">
                <p className="text-[14px] font-[700] leading-[24px]">Call: +91 7892516337</p>
              </a>
              <a href="mailto:care@designelementary.com">
                <p className="text-[14px] font-[700] leading-[24px]">Email: care@designelementary.com</p>
              </a>
              <div className="my-2 flex items-center justify-start">
                {/* Social Icons */}
                <div className="mx-2 rounded-lg bg-white p-1">
                  <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/DesignElementary/">
                    <FaFacebook className="text-[16px] text-black" />
                  </a>
                </div>
                <div className="mx-2 rounded-lg bg-white p-1">
                  <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/designelementary_global/">
                    <FaInstagram className="text-[16px] text-black" />
                  </a>
                </div>
                <div className="mx-2 rounded-lg bg-white p-1">
                  <a target="_blank" rel="noopener noreferrer" href="https://in.linkedin.com/company/design-elementary">
                    <FaLinkedin className="text-[16px] text-black" />
                  </a>
                </div>
                <div className="mx-2 rounded-lg bg-white p-1">
                  <a target="_blank" rel="noopener noreferrer" href="https://x.com/designelementa">
                    <FaTwitter className="text-[16px] text-black" />
                  </a>
                </div>
                <div className="mx-2 rounded-lg bg-white p-1">
                  <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UC72ZYAc9_Vu9DPqxVSDsBiw/">
                    <FaYoutube className="text-[16px] text-black" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="divider divider-horizontal opacity-[0.1] before:bg-[#E6E8EC!important] after:bg-[#E6E8EC!important] hidden md:flex"></div>
        </div>

        {/* Badges Section */}
        <div className="mx-auto flex w-full items-center justify-center">
          <div className="my-2 flex w-full flex-wrap items-start justify-center md:ml-0 md:w-fit md:items-center md:justify-evenly">
            <div className="md:mx-2 mx-1 my-1 flex w-fit items-center justify-evenly rounded-md border-2 border-white bg-[#284963] p-1 md:p-2">
              <img 
                src={"https://us.designelementary.com/footer/genuine-quality.png"}
                alt="Genuine Quality" 
                className="mx-auto w-[50px]"
              />
              <div className="mx-1 text-[16px] font-[600] md:mx-3">
                <p className="text-[#92a2b1]">Genuine</p>
                <p className="text-white">Quality</p>
              </div>
            </div>
            <div className="md:mx-2 mx-1 my-1 flex w-fit items-center justify-evenly rounded-md border-2 border-white bg-[#284963] p-1 md:p-2">
              <img 
                src="https://us.designelementary.com/footer/secured.png"
                alt="Secured Checkout" 
                className="mx-auto w-[50px]"
              />
              <div className="mx-1 text-[16px] font-[600] md:mx-3">
                <p className="text-[#92a2b1]">Secured</p>
                <p className="text-white">Checkout</p>
              </div>
            </div>
            <div className="md:mx-2 mx-1 my-1 flex w-fit items-center justify-evenly rounded-md border-2 border-white bg-[#284963] p-1 md:p-2">
              <img 
                src={"https://us.designelementary.com/footer/satisfaction.png"}
                alt="Satisfaction Guaranteed" 
                className="mx-auto w-[50px]"
              />
              <div className="mx-1 text-[16px] font-[600] md:mx-3">
                <p className="text-[#92a2b1]">Satisfaction</p>
                <p className="text-white">Guaranteed</p>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Copyright */}
        <p className="mx-auto w-11/12 py-2 text-[12px] font-[400] leading-[20px] md:hidden mb-24">
          © {new Date().getFullYear()} Design Elementary. All rights reserved
        </p>
      </div>
    </div>
  );
}